/**
 * Marchio di Bacco.
 *
 * Il nome, i colori e il claim provengono da `src/config/branding.ts`: nessun
 * componente ripete letteralmente il nome del prodotto o i suoi colori.
 */

import { branding } from '@/config/branding';
import { cn } from '@/lib/utils';

export function BaccoLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 40 40"
      className={cn('size-8', className)}
      role="img"
      aria-label={`Logo ${branding.productName}`}
    >
      {/* Calice stilizzato: la coppa richiama il vino, lo stelo la lettera B. */}
      <circle cx="20" cy="20" r="19" className="fill-primary" />
      <path
        d="M13 11h14v6.5a7 7 0 0 1-14 0V11Z"
        className="fill-primary-foreground"
        fillOpacity="0.95"
      />
      <path d="M19 24.5h2V29h4v2h-10v-2h4v-4.5Z" className="fill-primary-foreground" fillOpacity="0.95" />
      <path d="M13 11h14v3H13z" className="fill-accent" />
    </svg>
  );
}

export function BrandMark({ className, showTagline = false }: { className?: string; showTagline?: boolean }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <BaccoLogo />
      <span className="flex flex-col leading-none">
        <span className="text-lg font-semibold tracking-tight">{branding.productName}</span>
        {showTagline ? (
          <span className="mt-0.5 text-xs text-muted-foreground">{branding.productTagline}</span>
        ) : null}
      </span>
    </span>
  );
}
